import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import Features from '../components/Features';
import SupportSection from '../components/SupportSection';
import AdditionalSections from '../components/AdditionalSections';
import HowItWorks from '../components/HowItWorks';
import GettingStarted from '../components/GettingStarted';
import SystemRequirements from '../components/SystemRequirements';
import Testimonials from '../components/Testimonials';
import SupportIssues from '../components/SupportIssues';
import FaqSection from '../components/FaqSection';
import CtaBanner from '../components/CtaBanner';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#f4f7f5]">
      <Hero />
      <StatsBar />
      <Features />
      <SupportSection />
      <AdditionalSections />
      <HowItWorks />
      <CtaBanner
        kicker="Need a hand?"
        title="Hit a wall during setup? We can guide you through"
        text="Open live chat for install, upgrade, and migration help on Windows or Mac."
        buttonLabel="Chat with Support"
      />
      <div className="t7-section--defer">
        <GettingStarted />
        <SystemRequirements />
        <Testimonials />
        <SupportIssues />
        <FaqSection />
      </div>
      <CtaBanner
        variant="light"
        kicker="Ready to continue?"
        title="Keep your family history safe and accessible"
        text="TreeVault, sync, or missing media on your mind? Start a chat—we will map out clear next steps."
        buttonLabel="Open Live Chat"
      />
      <Footer />
    </div>
  );
}
